/**
 * The board: 4 columns by 5 rows on the wire, always. Rows 0–2 are the base game's (the three lines); rows 3–4 are the
 * GROW rows, blank and hidden under the frame unless the GROW booster is active in the bonus. Cells are indexed
 * row-major (`index = row * 4 + col`), so the base board is 0–11 and the GROW rows 12–19.
 */
export const GRID_SIZE = { columns: 4, rows: 5 } as const;

export const GRID_CELL_COUNT = GRID_SIZE.columns * GRID_SIZE.rows;

/** The base game's rows (and the bonus's without GROW). */
export const BASE_ROWS = 3;

export const BASE_CELL_COUNT = GRID_SIZE.columns * BASE_ROWS;

export function cellIndex(row: number, col: number): number {
  return row * GRID_SIZE.columns + col;
}

export function rowOf(index: number): number {
  return Math.floor(index / GRID_SIZE.columns);
}

export function columnOf(index: number): number {
  return index % GRID_SIZE.columns;
}

/** The cells of the board in play: the base rows, or all five with GROW. */
export function activeCells(grown: boolean): number[] {
  return Array.from({ length: grown ? GRID_CELL_COUNT : BASE_CELL_COUNT }, (_, i) => i);
}

/** A position mask: one '1' per listed cell, '0' elsewhere, over every cell of the wire board. */
export function maskOf(indices: Iterable<number>): string {
  const set = new Set(indices);
  return Array.from({ length: GRID_CELL_COUNT }, (_, i) => (set.has(i) ? "1" : "0")).join("");
}
